import { useDispatch, useSelector } from 'react-redux';
import React from 'react';

import { FieldsWrapper } from '../../../../../r/components/shared/input-field/styled';
import Input from '../../../../../r/components/shared/input-field/text';
import { updateFeedback, updateModel } from '../../reducers';
import { resetPassword } from '../../slices';
import { FormWrapper } from '../styled';
import FormFooter from '../form-footer';
import Feedback from '../feedback';

const ResetPassword = () => {
  const { model } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  
  const handleChange = ({ target: { value, id }}) => {
    dispatch(updateModel({
      [id]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(updateFeedback());
    dispatch(resetPassword());
  };

  return (
    <FormWrapper onSubmit={handleSubmit}>
      <div className="header">
        <h1>Reset Password</h1>
        <p>You are a few steps away from recovering your account!</p>
      </div>

      <FieldsWrapper>
        <Feedback />
        
        <Input
          placeholder="Enter email address"
          defaultValue={model.email}
          onChange={handleChange}
          label="Email Address"
          type="email"
          size="large"
          id="email"
          required
          block
        />
      </FieldsWrapper>

      <FormFooter />
    </FormWrapper>
  );
};

export default ResetPassword;